import React, { useState } from "react";
import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Button,
  Divider,
} from "@mui/material";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import { RxDashboard } from "react-icons/rx";
import { IoBagOutline } from "react-icons/io5";
import { GoTasklist } from "react-icons/go";
import { TiPointOfInterestOutline } from "react-icons/ti";
import { BsSignIntersectionY } from "react-icons/bs";
import { BiPurchaseTagAlt } from "react-icons/bi";
import { PiSubtitlesThin } from "react-icons/pi";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { FaSignOutAlt } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { logoutUser } from "../../Services/authService";
import { SIGNOUT_USER_SUCCESS } from "../../Redux/constants/AuthConstant";
import { useDispatch, useSelector } from "react-redux";
import { EventAvailableOutlined } from "@mui/icons-material";

const SideBar = ({ toggleSidebar }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { userResult } = useSelector((state) => state?.Auth);
  const [selected, setSelected] = useState(null);
  const dispatch = useDispatch();

  const handleClick = (path) => {
    navigate(path);
    toggleSidebar();
  };

  const menuItems = [
    { label: "Dashboard", icon: <RxDashboard />, path: "/admin" },
    {
      label: "Vendor Management",
      icon: <IoBagOutline />,
      path: "/admin/vendor",
      subPaths: ["/admin/posted_jobs", "/admin/view", "/admin/team-list"],
    },
    { label: "Job Management", icon: <GoTasklist />, path: "/admin/job" },
    {
      label: "Candidate Management",
      icon: <BsSignIntersectionY />,
      path: "/admin/candidate",
    },
    {
      label: "Interview Approvals",
      icon: <EventAvailableOutlined />,
      path: "/admin/interview/invitations",
    },
    {
      label: "Interviews Management",
      icon: <TiPointOfInterestOutline />,
      path: "/admin/interview",
    },
    {
      label: "Selected Candidate List",
      icon: <BiPurchaseTagAlt />,
      path: "/admin/selected-candidate",
    },
    {
      label: "Purchase Order List",
      icon: <AiOutlineShoppingCart />,
      path: "/admin/purchase_order",
    },
    {
      label: "Price Management",
      icon: <MonetizationOnOutlinedIcon />,
      path: "/admin/price-management",
    },
    {
      label: "Subscription",
      icon: <PiSubtitlesThin />,
      path: "/admin/subscription",
    },
  ];

  const isActive = (item) => {
    if (item.subPaths) {
      return (
        item.subPaths.some((p) => location.pathname === p) ||
        location.pathname === item.path
      );
    }
    return location.pathname === item.path;
  };

  const logoutHandler = () => {
    const userId = userResult?.adminid || localStorage.getItem("adminid");

    const userType = userResult.usertype || localStorage.getItem("usertype");
    logoutUser(parseInt(userId), userType).then(() => {
      navigate("/admin-login");
      setTimeout(() => {
        localStorage.clear();
        dispatch({
          type: SIGNOUT_USER_SUCCESS,
          payload: {},
          isSigninIn: false,
          msg: "logout successfully",
        });
      }, 400);
    });
  };

  return (
    <Box
      sx={{
        width: 250,
        height: "100%",
        bgcolor: "#fffefe",
        borderRight: "1px solid #eee6e4",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        overflowY: "auto",
      }}
    >
      {/* Menu Items */}
      <List>
        {menuItems.map((item, idx) => (
          <ListItemButton
            key={idx}
            selected={isActive(item)}
            onClick={() => handleClick(item.path)}
            sx={{
              color: isActive(item) ? "#0d47a1" : "#286A94",
              bgcolor: isActive(item) ? "#e6f0ff" : "transparent",
              "&:hover": {
                bgcolor: isActive(item) ? "#e6f0ff" : "#f5f5f5",
              },
              borderRadius: 1,
              m: 0.5,
            }}
          >
            <ListItemIcon sx={{ color: "inherit", minWidth: 32, fontSize: 20 }}>
              {item.icon}
            </ListItemIcon>
            <ListItemText
              primary={item.label}
              primaryTypographyProps={{ fontSize: 14, fontWeight: 500 }}
            />
          </ListItemButton>
        ))}
      </List>

      <Divider />

      {/* Logout Button */}
      <Box sx={{ p: 2 }}>
        <Button
          variant="contained"
          onClick={logoutHandler}
          startIcon={<FaSignOutAlt />}
          sx={{
            width: "100%",
            bgcolor: "#f44336",
            color: "#fff",
            fontWeight: 600,
            fontSize: 14,
            "&:hover": { bgcolor: "#d32f2f" },
          }}
        >
          Log Out
        </Button>
      </Box>
    </Box>
  );
};

export default SideBar;
